import React from 'react';
import Tooltip from '@mui/material/Tooltip';

interface ActionButtonProps {
  action?: () => void;
  children?: React.ReactNode;
  icon?: string;
  selected?: boolean;
  disabled?: boolean;
  size?: "xs" | "sm" | "md" | "lg";
  tooltip?: string;
  className?: string;
};

interface ActionButtonState {
  running?: boolean;
  selected?: boolean;
  disabled?: boolean;
  tooltip?: string;
};

export default class ActionButton extends React.Component<ActionButtonProps, ActionButtonState> {
  state = {
    running: false,
    selected: this.props.selected ? true : false,
    disabled: this.props.disabled ? true : false,
    tooltip: this.props.tooltip ? this.props.tooltip : ""
  }

  componentWillReceiveProps(nextProps: ActionButtonProps) {
    if (nextProps.disabled !== this.props.disabled) {
      this.setState({
        disabled: nextProps.disabled
      });
    }

    if (nextProps.selected !== this.props.selected) {
      this.setState({
        selected: nextProps.selected
      });
    }

    if (nextProps.tooltip !== this.props.tooltip) {
      this.setState({
        tooltip: nextProps.tooltip
      });
    }
  }

  runAction = async (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    event.preventDefault();

    if (this.props.action && !this.state.running && !this.state.disabled) {
      this.setState({
        running: true
      });

      await this.props.action();

      this.setState({
        running: false
      });
    }
  }

  render() {
    const { className, size } = this.props;
    const { selected, disabled, running } = this.state;

    const c = `action-button ${className ?? ""} ${size ?? ""} 
      ${selected ? " selected " : ""} ${disabled ? " disabled " : ""} ${running ? " running " : ""} `;

    const b = (
      <button className={c} onClick={this.runAction}>
        {this.props.icon && <i className={this.props.icon}></i>}
        {this.props.children}
        <div className="overlay"></div>
      </button>
    );

    return this.state.tooltip ? (
      <Tooltip title={<span className="action-button-tooltip">{this.state.tooltip}</span>}>
        {b}
      </Tooltip>) : b;
  }
}
